export default __webpack_public_path__ + "static/media/6.f60dbee8.jpg";